// extracted by mini-css-extract-plugin
export var animationAbsolute = "_2h-q";
export var animationRelative = "_2h-p";
export var backdropBlur = "_2h-0";
export var detailLabelCell = "_2h-12";
export var detailTable = "_2h-11";
export var detailValueCell = "_2h-13";
export var docIconBox = "_2h-1d";
export var docIconBoxMd = "_2h-1f";
export var docIconBoxSm = "_2h-1e";
export var docTypeRow = "_2h-16";
export var docTypeRowInner = "_2h-17";
export var dropdownMatchDatePicker = "_2h-3";
export var evidenceCardContent = "_2h-1c";
export var fileUploadSpin = "_2h-j";
export var gorgiasOpenButton = "_2h-15 _2h-d";
export var gorgiasTicketCard = "_2h-14";
export var heroModalFooterButton = "_2h-18";
export var hiddenContainer = "_2h-o";
export var iconPrimary = "_2h-1g";
export var iconSecondary = "_2h-1h";
export var iconTertiary = "_2h-1i";
export var integrationCard = "_2h-1";
export var integrationLogoBox = "_2h-2";
export var mainColumnSticky = "_2h-1b";
export var maxWidthContainer = "_2h-19";
export var modalContentBody = "_2h-a";
export var modalHeaderImage = "_2h-5";
export var modalImageLabel = "_2h-7";
export var modalImageOverlay = "_2h-6";
export var modalImageSubtitle = "_2h-9";
export var modalImageTitle = "_2h-8";
export var modalImageWrapper = "_2h-4";
export var modalStickyFooter = "_2h-b";
export var removeButton = "_2h-e";
export var sidebarColumn = "_2h-1a";
export var spinner = "_2h-i";
export var timelineLine = "_2h-y";
export var timelineLineBlack = "_2h-10 _2h-y";
export var timelineLineGray = "_2h-z _2h-y";
export var timelineLineHeight = "_2h-x";
export var tlDotActivate = "_2h-u";
export var tlDotActivateAnim = "_2h-t";
export var tlDotHide = "_2h-s";
export var tlDotHideAnim = "_2h-r";
export var tlLineActivate = "_2h-w";
export var tlLineActivateAnim = "_2h-v";
export var uploadHint = "_2h-n";
export var uploadIconBox = "_2h-k";
export var uploadLabel = "_2h-m";
export var uploadText = "_2h-l";
export var uploadZone = "_2h-f";
export var uploadZoneCursorDefault = "_2h-h";
export var uploadZoneCursorPointer = "_2h-g";
export var uploadedFileRow = "_2h-c";
export var viewButton = "_2h-d";